/**
 * @generated SignedSource<<1da415fab26d6200f53d9b35a8f5b482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DashboardMenuItemRefactored$data = {
  readonly dashboardId: AGG$Long;
  readonly favouriteValue: {
    readonly isFavourite: boolean | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardPopupMenuRefactored">;
  readonly " $fragmentType": "DashboardMenuItemRefactored";
};
export type DashboardMenuItemRefactored$key = {
  readonly " $data"?: DashboardMenuItemRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardMenuItemRefactored">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "DashboardMenuItemRefactored",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "title"
      },
      "action": "THROW",
      "path": "title"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "dashboardId"
      },
      "action": "THROW",
      "path": "dashboardId"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourite"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "DashboardPopupMenuRefactored"
    }
  ],
  "type": "JiraDashboard"
};

(node as any).hash = "bd58c2443da542685ca185eb4152abd6";

export default node;
